/* eslint-disable import/no-anonymous-default-export */
import HttpService from './http.service';

export interface Company {
  leadPrice: number | undefined;
  companyId: string;
  name: string;
  lastName: string;
  category: string;
  companyDescription: string;
  profileImage: string;
  profileImageUrl?: string;
  phone: string;
  yearsExperience: number;
  employeeCount: number;
  rating: number;
}

export interface SemanticSearchRequest {
  serviceDescription: string;
  cityName: string;
  categoryName?: string; // Campo opcional
}

class SemanticSearchService {
  async searchCompanies(conversationId: string, request: SemanticSearchRequest): Promise<Company[]> {
    try {
      const response = await HttpService.post<Company[]>(`/api/AI/conversations/${conversationId}/semantic-search`, request);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

//export default new SemanticSearchService();
const semanticSearchService = new SemanticSearchService();
export default semanticSearchService;
